import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { Approach } from './components/Approach';
import { Values } from './components/Values';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-ivory text-navy overflow-x-hidden" data-id="element-0" data-mp="2rlf6csv3xo2u">
      <Navbar data-id="element-1" data-mp="2mmvj8p4s268w" />
      <main data-id="element-2" data-mp="2mndqegsza4vl">
        <Hero data-id="element-3" data-mp="2mnngs5hxqe1t" />
        <About data-id="element-4" data-mp="2mjzlb0sxjhkg" />
        <Services data-id="element-5" data-mp="31agn4l9h89hv" />
        <WhyUs data-id="element-6" data-mp="31ayr642drs0c" />
        <Approach data-id="element-7" data-mp="31bib1qblcqh0" />
        <Values data-id="element-8" data-mp="31c1i2bzpdug9" />
        <CTA data-id="element-9" data-mp="31cjmvx0flgzs" />
      </main>
      <Footer data-id="element-10" data-mp="2wk9y4kb1ymz3" />
    </div>;
}